import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { slideBottomUpAnimations } from "@circle-react-uikit/animations";
import { usePlans } from "../../../RegularPlan/PlansContext";
import { CollapsedCheckoutView } from "./CollapsedCheckoutView";
import { ExpandedCheckoutView } from "./ExpandedCheckoutView";

export const MobileCheckoutOverlay = () => {
  const { selectedPlan } = usePlans();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!selectedPlan) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 md:hidden">
      {/* Overlay backdrop when expanded */}
      <Transition
        show={isExpanded}
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div
          className="fixed inset-0 bg-black/50"
          onClick={() => setIsExpanded(false)}
          aria-hidden="true"
        />
      </Transition>

      {/* Bottom overlay */}
      <div className="bg-primary border-primary relative border-t px-5 py-4 shadow-lg">
        {/* Collapsed view */}
        {!isExpanded && (
          <CollapsedCheckoutView
            onExpand={() => setIsExpanded(true)}
            selectedPlan={selectedPlan}
          />
        )}

        {/* Expanded view */}
        <Transition
          show={isExpanded}
          as={Fragment}
          {...slideBottomUpAnimations}
        >
          <ExpandedCheckoutView
            onCollapse={() => setIsExpanded(false)}
            selectedPlan={selectedPlan}
          />
        </Transition>
      </div>
    </div>
  );
};
